import { AssignAllDiagnosticModel, AssignDiagnosticLessonsModel, AssignStudentDiagnosticLessonsModel, AssignStudentDiagnosticModel, 
    CreateDiagnosticVM, DiagnosticRemoveFromSkipStudentModel, DiagnosticSkipStudentModel, StudentForDiagnostic, DiagnosticLessonsSkipStudentModel, 
    UnassignDiagnosticLessonsVM , SubmitViewWorkModel, ViewWorkDataModel, ViewWorkDataVM, SubmitViewWorkResponseModel, DiagnosticVM, 
    DiagnosticsVM, DiagnosticsList, ClassForListing, LessonProgressReleaseAllByAssignment, LessonProgressReleaseAllByStudent, 
    LessonProgressSaveModel, LessonProgressSaveGradeModel, LessonProgressLockSaveModel, ReassignStudentModel, GradebookVM, 
    StudentVM, AssignmentVM, StudentLesson, Lesson, ELearningDashboardState, ELearningDashboardClass, Teachers, UnAssignModel, 
    ClassWithStudentsForListing, CreateAssignmentOptions, CreateAssignmentsModel, CreateAccountModel, CurriculaVMModel, 
    ExistingStudentCurriculumRegisterModel, RegisterNewStudent, SelectedCurriculumModel, StudentModel, StudentCourseModel, 
    CurriculumViewListing, CurriculumProductLevelPrice, PaymentProviderRequestResult, PaymentFailureRedirectModel, PaymentSuccessRedirectModel, 
    SelfServiceGetLessonModel, SelfGetLessonReturnModel, GetDemoRedirectModel, DemoRedirectModel, LoginAccountModel, LoginAccountResult,
    ConsumerCurriculumJargon, DiagnosticReport, StudentConsumerCurriculum,
    LoginAsStudentModel,
    DemoResultData, EmailConfirmationModel, ExistingStudentConsumerCurriculumRegisterModel, DiagnosticReportRequest, StandardGrowthModel, StandardsGrowthReportModel, HasAlreadyPaidRedirectModel, ViewWorkDialogAssignmentAttempt, NotLoggedInReturnModel} from './../../Elearning-Models';

import { Observable } from 'rxjs';
import { IServiceFactory } from '../service-factory';


export abstract class IAPIService {
    abstract IsLoggedIn(): Observable<NotLoggedInReturnModel>;
    
    
    
    abstract SetServiceFactory(service: IServiceFactory): void;
    abstract GetClassesForTeacher(): Observable<ELearningDashboardClass[]>;
    abstract GetTeachersForAdmin(): Observable<Teachers>;
    abstract UpdateDashboardVisibility(HBClassID: number, visibility: boolean): Observable<boolean>;
    abstract GetClassesForAdminFromTeacherID(teacherID: number): Observable<ELearningDashboardClass[]>;
    abstract GetLinksForAdmin(): Observable<number[]>;

    abstract SaveELearningDashboardState(state: ELearningDashboardState): Observable<boolean>;
    abstract GetELearningDashboardState(): Observable<string>;

    abstract GetStudentLessons(lessonid: number):Observable<StudentLesson[]>;
    abstract GetLessonByID(lessonid: number): Observable<Lesson>;

    abstract GetAllGradebookDataForUser();

    abstract GetLessonProgressByStudentID(classid: number, studentid: number) : Observable<StudentVM>;
    abstract GetLessonProgressByLessonVersionID(classid: number, lessonversionid: number): Observable<AssignmentVM>;
    abstract GetLessonProgressByClassID(classid: number) : Observable<GradebookVM>;
    abstract GetLessonProgressByStudentAndLessonVersionID(classid: number, studentid: number, lessonversionid: number): Observable<StudentVM>;

    abstract ReassignStudent(model: ReassignStudentModel) : Observable<boolean>;
    abstract LockAssignmentForStudent(model: LessonProgressLockSaveModel) : Observable<boolean>;
    abstract SaveGradeForStudent(model: LessonProgressSaveGradeModel) : Observable<boolean>;
    abstract ReleaseGradeForStudent(model: LessonProgressSaveModel) : Observable<boolean>;
    abstract ReleaseKeyForStudent(model: LessonProgressSaveModel) : Observable<boolean>;
    abstract UnassignOneOrAllAssignments(model: UnAssignModel): Observable<boolean>;

    abstract ReleaseAllGradesByStudentID(model: LessonProgressReleaseAllByStudent): Observable<boolean>;
    abstract ReleaseAllGradesByAssignmentID(model: LessonProgressReleaseAllByAssignment) : Observable<boolean>;

    abstract GetClassListByTeacher() : Observable<ClassForListing[]>;
    abstract GetClassListByTeacherAndStudentID(studentID: number) : Observable<ClassForListing[]>;

    abstract GetDiagnosticDataForTeacher(): Observable<DiagnosticsVM[]>;
    abstract GetDiagnosticDataForAdminByTeacherID(teacherID: number): Observable<DiagnosticsVM[]>;
    abstract GetDiagnosticDataByDiagnosticExamID(diagnosticExamID: number): Observable<DiagnosticVM>;
    abstract GetDiagnosticListForTeacher(hbcID: number): Observable<DiagnosticsList[]>;
    abstract GetSkippedStudentsList(diagExamID: number): Observable<StudentForDiagnostic[]>;

    abstract DiagnosticSkipStudent(model: DiagnosticSkipStudentModel): Observable<boolean>;
    abstract AssignStudentDiagnostic(model: AssignStudentDiagnosticModel): Observable<boolean>;
    abstract AssignAllDiagnostic(model: AssignAllDiagnosticModel): Observable<boolean>;

    abstract DiagnosticLessonsSkipStudent(model: DiagnosticLessonsSkipStudentModel): Observable<boolean>;

    abstract DiagnosticRemoveFromSkipStudent(model: DiagnosticRemoveFromSkipStudentModel): Observable<boolean>;
    abstract DiagnosticRemoveFromLessonsSkipStudent(model: DiagnosticRemoveFromSkipStudentModel): Observable<boolean>;

    abstract AssignDiagnosticLessons(model: AssignDiagnosticLessonsModel): Observable<boolean>;
    abstract AssignStudentDiagnosticLessons(model: AssignStudentDiagnosticLessonsModel): Observable<boolean>;

    abstract UnassignDiagnosticLessons(model: UnassignDiagnosticLessonsVM): Observable<boolean>;

    abstract CreateDiagnostic(model: CreateDiagnosticVM) : Observable<DiagnosticVM>;



    abstract GetViewWorkData(model: ViewWorkDataModel): Observable<ViewWorkDataVM>;
    abstract SubmitViewWorkData(model: SubmitViewWorkModel): Observable<SubmitViewWorkResponseModel>;

    abstract CreateAssignments(model: CreateAssignmentsModel): Observable<boolean>;
    abstract GetDefaultAssignmentOptions(): Observable<CreateAssignmentOptions>;
    abstract GetClassesWithStudent(): Observable<ClassWithStudentsForListing[]>;
    abstract GetClassWithStudents(classID: number): Observable<ClassWithStudentsForListing>;

    abstract CreateAccount(model: CreateAccountModel): Observable<boolean>;
    abstract GetUserDetailsForEdit(): Observable<CreateAccountModel>;
    abstract EditUser(model: CreateAccountModel): Observable<boolean>;

    abstract GetCurriculumData(): Observable<CurriculaVMModel>;

    abstract AssignCurriculum(model: ExistingStudentCurriculumRegisterModel): Observable<PaymentProviderRequestResult>;
    abstract AssignCurriculumForStudentConsumerCurriculum(model: ExistingStudentConsumerCurriculumRegisterModel): Observable<PaymentProviderRequestResult>;
    abstract GetStudentList(): Observable<StudentModel[]>;

    abstract GetSelectedCurriculum(curriculumID: number): Observable<SelectedCurriculumModel>;
    abstract RegisterNewStudent(model: RegisterNewStudent): Observable<number>;
    abstract GetStudentCourseList(): Observable<StudentCourseModel>;
    abstract GetStudentLesson(model: SelfServiceGetLessonModel): Observable<SelfGetLessonReturnModel>;
    abstract LoginAndGetStudentDemo(model: SelfServiceGetLessonModel): Observable<SelfGetLessonReturnModel>;

    abstract GetCurriculumViewDataByClassId(classID: number): Observable<CurriculumViewListing>;

    abstract GetCurriculumProductLevelPrice(curriculumID: number): Observable<CurriculumProductLevelPrice[]>;

    abstract GetRedirectModelFromProcessPaymentFailure(guid: string): Observable<PaymentFailureRedirectModel>;

    abstract GetRedirectModelFromProcessPaymentSuccess(guid: string): Observable<PaymentSuccessRedirectModel>;

    abstract ShowGradebookStudentAssignmentPagesCreateAssignmentInterfaces(): Observable<boolean>;

    abstract ValidateUserName(email: string): Observable<boolean>;

    abstract GetDemoRedirect(model: GetDemoRedirectModel): Observable<DemoRedirectModel>;

    abstract LoginUser(data: LoginAccountModel): Observable<LoginAccountResult>;

    abstract GetConsumerCurriculumJargon(): Observable<ConsumerCurriculumJargon>;
    abstract GetConsumerCurriculumDiagnosticReport(model: DiagnosticReportRequest): Observable<DiagnosticReport>;

    abstract GetStudentConsumerCurriculum(StudentID: number, curriculumID: number): Observable<StudentConsumerCurriculum>;
    
    abstract LoginAsStudent(model: LoginAsStudentModel): Observable<boolean>;

    abstract GetDemoResultData(studentConsumerCurriculumID: number): Observable<DemoResultData>;

    abstract GetDemoResultDataByStudentAndClass(studentID: number, classID: number): Observable<DemoResultData>;

    abstract ValidateParentPassword(pass: string): Observable<boolean>;

    abstract GetIsTeacher(): Observable<boolean>;

    abstract CheckIsNewComer(): Observable<boolean>;
    abstract ConfirmEmail(guid: string): Observable<EmailConfirmationModel>;
    abstract ConfirmEmailByUser(): Observable<EmailConfirmationModel>;
    abstract ResendConfirmationEmail(guid: string): Observable<boolean>;

    abstract GetStandardsGrowthReport(classid: number): Observable<StandardsGrowthReportModel>;

    abstract IsConsumerCurriculum(): Observable<boolean>;

    abstract HasAlreadyPaidByStudentConsumerCurrID(sccID: number): Observable<HasAlreadyPaidRedirectModel>;
    abstract HasAlreadyPaidByStudentClassID(studentID: number, classID: number): Observable<HasAlreadyPaidRedirectModel>;

    abstract GetAssignmentAttemptsForViewWorkDialog(studentID: number, assignmentID: number): Observable<ViewWorkDialogAssignmentAttempt[]>;

}
